import React from 'react';
import Footer from '../components/Footer';
import Nav from '../components/Nav';
import BottomNav from '../components/BottomNav';
import ChoirSlider from '../components/ChoirSlider';
import headshot from '../assets/images/padrones.jpg';

function About() {
	return (
		<div className='flex flex-col'>
			<Nav />
			<div className='bg-info text-base-100'>
				<h1 className='p-10 text-center font-heading text-2xl'>
					About Our Program
				</h1>
			</div>
			<div className='flex justify-center bg-secondary p-10 text-center'>
				<p className='max-w-4xl'>
					The chorus program at Marshall is made up of 6th, 7th, and 8th graders
					that perform in various ensembles. We put on 3 major performances a
					year, including a staged musical. These performance groups have
					different levels of skill so all are welcome to join!
				</p>
			</div>
			<div className='flex flex-col items-center gap-14 py-20 px-10 md:flex-row md:justify-center'>
				<div className='w-72 md:w-96'>
					<img
						alt='Jeremy Padrones headshot'
						src={headshot}
						className='h-full rounded'
					/>
				</div>
				<div className='flex flex-col gap-3'>
					<h2 className='font-lora text-3xl font-bold'>Choir Director</h2>
					<h3 className='font-lora text-xl font-bold'>Jeremy Padrones</h3>
					<p className='max-w-2xl'>
						Jeremy Padrones is the director of choirs at Marshall Academy of the
						Arts. He received his Bachelors of Music Education from California
						State University Long Beach in 2017. He's been honored to have been
						teaching at Marshall since 2018. He has a passion for teaching,
						choral music, musical theater, and music technology. Since being at
						Marshall, the program has been able to put on wonderful concerts and
						exciting musicals each year. He loves Marshall and is honored to
						grow this music community here.
					</p>
				</div>
			</div>
			<ChoirSlider />
			<div className='flex flex-col items-center gap-2 bg-accent py-20 px-10 text-center'>
				<h2 className='font-lora text-5xl font-bold'>Auditions</h2>
				<h3 className='font-lora text-2xl font-bold'>
					Auditions Required for Vocal Ensemble
				</h3>
				<p>
					Auditions are only required for Vocal Ensemble (7th and 8th Graders
					only). These will take place at the beginning of the year and details
					will be shared during class. There are also auditions in preparation
					for the Spring Musical. Those details will be shared during the school
					year prior to the Spring semester.
				</p>
			</div>

			<BottomNav />
			<Footer />
		</div>
	);
}
export default About;
